<div class="skeletor-types">
  <div class="skeletor-types-header">
    <p-skeleton [width]="'16rem'" [height]="'1.2rem'" />
    <p-skeleton [width]="'24rem'" [height]="'1rem'" />
  </div>

  <div class="skeletor-types-panel">
    <div class="skeletor-types-toolbar">
      <div>
        <p-skeleton [width]="'12rem'" [height]="'1rem'" />
        <p-skeleton [width]="'20rem'" [height]="'0.9rem'" />
      </div>
      <p-skeleton [width]="'12rem'" [height]="'2.2rem'" />
    </div>

    <div class="skeletor-types-list">
      <div class="skeletor-types-item" *ngFor="let i of rows">
        <p-skeleton [width]="'14rem'" [height]="'1rem'" />
        <p-skeleton [width]="'20rem'" [height]="'0.9rem'" />
      </div>
    </div>
  </div>

  <div class="skeletor-types-section">
    <p-skeleton [width]="'14rem'" [height]="'1rem'" />
    <p-skeleton [width]="'24rem'" [height]="'0.9rem'" />

    <div class="skeletor-types-field" *ngFor="let i of rows">
      <div class="skeletor-types-field-head">
        <p-skeleton shape="rectangle" [width]="'1.2rem'" [height]="'1.2rem'" />
        <p-skeleton [width]="'12rem'" [height]="'1rem'" />
        <p-skeleton [width]="'6rem'" [height]="'1.2rem'" />
      </div>
      <p-skeleton [width]="'8rem'" [height]="'0.9rem'" />
    </div>
  </div>

  <div class="skeletor-types-subsection">
    <p-skeleton [width]="'12rem'" [height]="'1rem'" />
    <div class="skeletor-types-doc" *ngFor="let i of rows">
      <div class="skeletor-types-doc-head">
        <div>
          <p-skeleton [width]="'14rem'" [height]="'1rem'" />
          <p-skeleton [width]="'26rem'" [height]="'0.9rem'" />
        </div>
        <div class="skeletor-types-actions">
          <p-skeleton [width]="'6rem'" [height]="'2rem'" />
          <p-skeleton [width]="'6rem'" [height]="'2rem'" />
          <p-skeleton [width]="'6rem'" [height]="'2rem'" />
        </div>
      </div>
      <div class="skeletor-types-role">
        <p-skeleton [width]="'12rem'" [height]="'0.9rem'" />
        <p-skeleton [width]="'16rem'" [height]="'2.2rem'" />
      </div>
    </div>
  </div>
</div>

